<div class="container">
  <div class="title title--xlg">
    {{institutionTitle}}
    <div class="m-0 align-center subtitle subtitle--description-bold font-size-12" [innerHtml]="this.getSubtext()"></div>
  </div>
</div>